import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { IDisplayBooking } from '../place-bookings.component';

export interface IBbitPlaceBookingCancellationOverlayData {
  event: IDisplayBooking;
}

export class PlaceBookingCancellationOverlayRef {
  private _data!: IBbitPlaceBookingCancellationOverlayData;
  private _onClose = new Subject<boolean>();
  public constructor(private _overlayRef: OverlayRef) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public setData(data: IBbitPlaceBookingCancellationOverlayData): void {
    this._data = data;
  }

  public getData(): IBbitPlaceBookingCancellationOverlayData {
    return this._data;
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
